import { LineItem } from "../../interfaces/LineItem";

export const defaultLineItem: LineItem = {
  type: "",
  order: "",
  name: "",
  quantity: 0,
  uom: "",
  total_uc: 0,
  total: 0,
  markup_allocation: 0,
  total_plus_markup: 0,
  labor_uc: 0,
  prod_rate: 0,
  labor_rate: 0,
  material_uc: 0,
  sub_uc: 0,
  equip_uc: 0,
  other_uc: 0,
  lmseo_prorated: false,
  labor_rate_prorated: false,
  use_group: "",
  notes: "",
  created_at: "",
  updated_at: "",
  id: "",
  product: "",
} as LineItem;

export const splitLineItemsByDimension = (
  items: LineItem[],
  groups: any[],
  dimensionKey: "floor_group" | "use_group",
  valueKey: string,
  getGroupName: (group: any) => string,
  additionalFilter?: (group: any, item: LineItem) => boolean
): LineItem[] => {
  return items.flatMap((item) => {
    const totalCost = typeof item.total === "string" ? 0 : item.total || 0;

    const validGroups = groups
      .map((group) => {
        const groupName = getGroupName(group);
        return {
          ...group,
          groupName,
          value: item[`${groupName}${valueKey}`] || 0,
        };
      })
      .filter((g) => {
        if (!item[dimensionKey].includes(g.groupName)) return false;
        return additionalFilter ? additionalFilter(g, item) : true;
      });

    if (validGroups.length === 0) return [item];

    if (validGroups.length === 1) {
      return [
        {
          ...item,
          [dimensionKey]: validGroups[0].groupName,
          ...Object.fromEntries(
            groups.map((group) => {
              const groupName = getGroupName(group);
              return [`${groupName}${valueKey}`, groupName === validGroups[0].groupName ? validGroups[0].value : 0];
            })
          ),
        },
      ];
    }

    return validGroups.map((vg) => ({
      ...item,
      total: typeof item.total === "string" ? item.total : vg.value,
      quantity: totalCost !== 0 ? item.quantity * (vg.value / totalCost) : 0,
      [dimensionKey]: vg.groupName,
      ...Object.fromEntries(
        groups.map((group) => {
          const groupName = getGroupName(group);
          return [`${groupName}${valueKey}`, groupName === vg.groupName ? vg.value : 0];
        })
      ),
    }));
  });
};
